import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
    selector: 'chevron-cell',
    templateUrl: './chevron-renderer.component.html',
    standalone: false
})
export class ChevronRendererComponent implements ICellRendererAngularComp {
  hidechevron: boolean = false;
  constructor() {
  }

  // called on init
  agInit(params: any): void {
    this.initilize(params);
  }

  // called when the cell is refreshed
  refresh(params: any): boolean {
    this.initilize(params);
    return true;
  }
  initilize(params: ICellRendererParams) {
    if (params.data && params.data.hidechevron) {
      this.hidechevron = true;
    }
  }
}
